import React, { Component } from 'react';
import Header from '../../Layout/Header'
import { Link } from 'react-router-dom'
// import Sidebar from '../Blog/Sidebar'

class PublicRelations extends Component {
	render() {
		return (
<div>
				<Header
					seoTitle="Public Relations"
					title={"public relations"}
					image={require('./image-4.jpg')}
				/>
				<div className="entry-content page-blog">


				<div className="container-fluid">
                       			<h2 className="outline text-center">
                            			<div className="line"></div>
                            			<div className="title">
                               			   <img
                                    			src={require("./moshi-icon.png")}
                                    			alt="Icon"
                                    			width="48"
                                    			style={{
                                    			marginTop: -18,
                                    			marginBottom: -12,
                                    			marginRight: 12
                                		   }}/>
                               			 Public Relations
                            			</div>
                       			 </h2>
                    		</div>

					
					<div className="container">
						
						<div className="row">
							<div className="col-lg-12">
							
								
								<p>Public Relations refers to how your company is seen to the public. That includes who you’re affiliated with, your sponsor partners, your voice, your brand, your events and your actions. Whether you’re a small or large business, keeping your public profile updated is crucial. </p>
<p>A large part of your public facing persona is your social media and online presence. Your potential customers will usually research you on either Instagram or Facebook first - to see your ratings, your mission, your communication and your overall company aesthetic - do you look like someone they want to work with or buy from?</p>


								<h4>Moshi Moshi Marketing's Public Relations services include:</h4>
								
  <ul class="with-icons">
              <li>Management of small internal company events</li>
<li>Assistance with the organisation of larger external events</li> 
<li><a href="https://www.moshi.com.au/whatwedo/social-media-management">Social media management and content creation</a></li>
<li><a href="https://www.moshi.com.au/whatwedo/website-and-newsletter-content-writing">Website content and proofreading</a></li>
<li>Press releases for events</li>
<li><a href="https://www.moshi.com.au/whatwedo/website-and-newsletter-content-writing">Newsletter content writing</a></li>
<li>Sponsorship alignment proposals</li>

</ul>


     
    <p>Customers expect transparent, authentic content. Creating consistent messaging across all of your outgoing communications is a sure way to build trust and establish authenticity. 
</p>


<a href="https://www.moshi.com.au/what-weve-done/prince-hotel"><img src={require('./newsletter.png')} style={{padding: 30}} height="375" width="350" alt="Prince of Wales Newsletter Content Writing" className="align-centre" align="centre" /></a>
<img src={require('./assist.png')} style={{padding: 30}} height="375" width="350" alt="Telethon Calendar Shoot" className="align-centre" align="centre" />
<img src={require('./social-manage.png')} style={{padding: 30}}  height="375" width="350" alt="Inspired Interiors Instagram Content" className="align-centre" align="centre" />

<br></br>
<hr></hr>
<h2>Related Services</h2>

<a class="btn" href="https://www.moshi.com.au/whatwedo/website-and-newsletter-content-writing">Website and Newsletter Content Writing</a>
<a class="btn" href="https://www.moshi.com.au/whatwedo/email-newsletter-marketing">Email Newsletter Marketing</a> 
<a class="btn" href="https://www.moshi.com.au/whatwedo/photography-and-video-shoots">Photography and Video Shoots</a>
<a class="btn" href="https://www.moshi.com.au/whatwedo/video-production-and-advertising">Video Production and Advertising</a>
<a class="btn" href="https://www.moshi.com.au/whatwedo/social-media-management">Social Media Management</a>
		
<a class="btn" href="https://www.moshi.com.au/whatwedo/brand-and-logo-design">Brand and Logo Design</a>	

		
<hr></hr>
<br></br>	
		
		

						
							</div>
							{/* <div className="col-lg-4">
								<Sidebar />
							</div> */}
						</div>
<h3>If you want to host an event, you’re on the lookout for sponsorships or your social profile needs a bit of a makeover, let the team at Moshi Moshi help you out. </h3>
					</div>
				</div>

			</div>
		);
	}
}

export default PublicRelations;


// WEBPACK FOOTER //
// ./src/Pages/WhatWeDo/PublicRelations.js